import React, { Component } from 'react';

import Paper from 'material-ui/Paper';

import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import BridgeAppBar from './MainComponents/BridgeAppBar';
import clientsStore from '../stores/clientsStore';

// import _ from 'lodash';
var extendedOutput = [];
var extendedLogText = [];


const CommandLog = ({indice, command}) => (
    <Paper className="commandItem">
        <div style={{paddingLeft: "28px", marginBottom: "8px"}}>Codigo de log: { command.commandLogID } </div>
        <div>
            <div style={{display: "inline-block"}}>
                <ChevronRight 
                    onTouchTap={() => {
                        extendedLogText[indice] = !extendedLogText[indice];
                        var extLogText = document.getElementsByClassName("extLogText")[indice];
                        extLogText.style.whiteSpace = extendedLogText[indice] ? "normal" : "nowrap";
                    }} color={"#757575"} cursor={"pointer"}/> 
            </div>
            <div className="extLogText"
                style={{
                    width: "80%", whiteSpace: "nowrap" , overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", 
                    verticalAlign: "top", fontSize: "18px", fontWeight: "300"
                }}> { command.commandLogText }
            </div>
        </div>
        <div>
            <div style={{display: "inline-block"}}>
                <ChevronRight 
                    onTouchTap={() => {
                        extendedOutput[indice] = !extendedOutput[indice];
                        var extOutput = document.getElementsByClassName("extOutput")[indice];
                        extOutput.style.whiteSpace = extendedOutput[indice] ? "normal" : "nowrap";
                    }} color={"#757575"} cursor={"pointer"}/> 
            </div>
            <div className="extOutput"
                style={{
                    width: "80%", whiteSpace: "nowrap" , overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", 
                    verticalAlign: "top", fontSize: "18px", fontWeight: "300"
                }}> { command.commandOutput }
            </div>
        </div>
            
        <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Código de comando:</span> { command.commandID } </div>
        <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>CommandLog date:</span> { command.commandLogDate } </div>
    </Paper>
    
);



const CommandLogList = ({logs, logsize}) => (
    <div>
        {
            logs.map((item, index) =>(

                <CommandLog 
                    key={index}
                    command={item}
                    indice={index}
                />
            )) 
        } 
    </div>
);

class Logs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logs: [],
            clientName: ""
        }
    }

     componentDidUpdate() {
        extendedOutput = Array(this.state.logs.length).fill(false);
        extendedLogText = Array(this.state.logs.length).fill(false);
    } 

    componentDidMount() {
        clientsStore.getCommandLogs({
            id: this.props.match.params.id,
            onSuccess: (response) => {
                this.setState({logs: response});
            }
        });
        clientsStore.getClients({
            id:this.props.match.params.id,
            onSuccess: (response) => {
                this.setState({clientName: response.clientName});
            }
        });
    }
    render() {
        return (
            <div>
                <BridgeAppBar 
                    toClient={{ url: "/clientdetails/" + this.props.match.params.id, display: this.state.clientName }}
                    toStoredCommands={"/storedcommands/" + this.props.match.params.id} 
                    toCommands={"/commands/" + this.props.match.params.id} 
                    toLogs={"/logs/" + this.props.match.params.id} 
                />
                <h1 style={{textAlign:'center'}}>CommandLogs de {this.state.clientName} </h1><br />
                <CommandLogList 
                    logs={this.state.logs}
                    logsize={this.state.logs.length} 
                />
            </div>
        );
    }
}

export default Logs;


// WEBPACK FOOTER //
// ./src/components/Logs.js